import React from "react";
import styled from "styled-components";

const Img = styled.img`
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.1);
  border: 1px solid #ccc;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 16/9;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  }
`;

const Placeholder = styled.div`
  width: 120px;
  height: 120px;
  background: #f4f4f4;
  border: 1px dashed #ccc;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
  font-size: 0.8rem;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 400px;
    height: auto;
    aspect-ratio: 16/9;
    font-size: 1rem;
  }
`;

const Thumbnail = ({ url }) => {
    return url ? <Img src={url} alt="preview" /> : <Placeholder>No Preview</Placeholder>;
};

export {Thumbnail};
